import TagLegal from './TagLegal.vue';

export default TagLegal;
